export default __webpack_public_path__ + "static/media/640_dummy2016-ferienwohnung01-mobile-de.98845662.png";